angular.module('rjmNg.constants')
.constant("rjpopoverGroupNames"
  VISUAL_REPORT_BUILDER: "visual-report-builder"
  DASHBOARDS: "dashboards"
)